import {
  Users,
  LayoutDashboard,
  Package,
  FileText,
  Settings,
  MessageSquare,
  Bell,
} from "lucide-react";
import { LucideIcon } from "lucide-react";

export interface AdminMenuItem {
  name: string;
  path: string;
  icon: LucideIcon;
}

export const adminMenuItems: AdminMenuItem[] = [
  {
    name: "Dashboard",
    path: "/admin/dashboard",
    icon: LayoutDashboard,
  },
  {
    name: "Users",
    path: "/admin/users",
    icon: Users,
  },
  {
    name: "Products",
    path: "/admin/products",
    icon: Package,
  },
  {
    name: "Orders",
    path: "/admin/orders",
    icon: FileText,
  },
  {
    name: "Queries",
    path: "/admin/queries",
    icon: MessageSquare,
  },
  {
    name: "Notify Me",
    path: "/admin/notify-me",
    icon: Bell,
  },
  {
    name: "Settings",
    path: "/admin/settings",
    icon: Settings,
  },
];

